import React, { useCallback } from 'react';
import Basket from '../../track/ground/background/Basket';
import Volleyball from '../../track/ground/background/Volleyball';
import Football from '../../track/ground/background/Football';
import GaelicFootball from '../../track/ground/background/GaelicFootball';
import Futsal from '../../track/ground/background/Futsal';
import Handball from '../../track/ground/background/Handball';
import Rugby from '../../track/ground/background/Rugby';
import IceHockey from '../../track/ground/background/IceHockey';
import ShortTrack from '../../track/ground/background/ShortTrack';
import Fencing from '../../track/ground/background/Fencing';
import Tennis from '../../track/ground/background/Tennis';
import { GroundType } from '../../../models/ground';
import { GroundGeometry } from '../../../types/webPlayer';
import { StringNumberGenericValueType } from '../../athlete/defines';
import { CenterVertices } from '../VectorGround';

type editDataProps = {
  groundType: string,
  groundSurfaceColor: string,
  vertexAX?: StringNumberGenericValueType,
  vertexAY?: StringNumberGenericValueType,
  vertexBX?: StringNumberGenericValueType,
  vertexBY?: StringNumberGenericValueType,
  vertexCX?: StringNumberGenericValueType,
  vertexCY?: StringNumberGenericValueType,
}

type PropsPitch = {
  debug?: boolean;
  defaultGround: boolean;
  groundData?: GroundType | editDataProps;
  scale: number;
  vertices?: boolean,
  showInDrawer?: boolean,
  groundGeometry: GroundGeometry & {centerVertices: CenterVertices},
};

export default function Pitch ( props: PropsPitch ) {
  const {
    debug,
    defaultGround,
    groundData,
    groundGeometry,
    scale,
    showInDrawer,
    vertices,
  } = props;

  if (debug) {
    console.log(`[DEBUG] Pitch: ${groundData?.groundType}`, groundGeometry, groundData);
  }

  // console.log('centerVertices', groundGeometry.centerVertices)

  const groundType = useCallback(( groundDataObj, type: string ) => {
    if (type === 'BASKET') {
      return (
        <Basket
          debug={debug}
          groundData={groundDataObj}
          scale={scale}
          vertices={vertices ?? false}
          groundGeometry={groundGeometry}
        />
      );
    }
    if (type === 'VOLLEYBALL') {
      return (
        <Volleyball
          debug={debug}
          groundData={groundDataObj}
          scale={scale}
          vertices={vertices ?? false}
          groundGeometry={groundGeometry}
        />
      );
    }
    if (type === 'FOOTBALL') {
      return (
        <Football
          debug={debug}
          groundData={groundDataObj}
          scale={scale}
          vertices={vertices ?? false}
          groundGeometry={groundGeometry}
        />
      );
    }
    if (type === 'GAELIC_FOOTBALL') {
      return (
        <GaelicFootball
          debug={debug}
          groundData={groundDataObj}
          scale={scale}
          vertices={vertices ?? false}
          groundGeometry={groundGeometry}
        />
      );
    }
    if (type === 'FUTSAL') {
      return (
        <Futsal
          debug={debug}
          groundData={groundDataObj}
          scale={scale}
          vertices={vertices ?? false}
          groundGeometry={groundGeometry}
        />
      );
    }
    if (type === 'HANDBALL') {
      return (
        <Handball
          debug={debug}
          groundData={groundDataObj}
          scale={scale}
          vertices={vertices ?? false}
          groundGeometry={groundGeometry}
        />
      );
    }
    if (type === 'RUGBY' || groundDataObj?.groundType === 'RUGBY_HALF') {
      return (
        <Rugby
          debug={debug}
          groundData={groundDataObj}
          scale={scale}
          vertices={vertices ?? false}
          groundGeometry={groundGeometry}
        />
      );
    }
    if (type === 'ICE_HOCKEY') {
      return (
        <IceHockey
          debug={debug}
          groundData={groundDataObj}
          scale={scale}
          vertices={vertices ?? false}
          groundGeometry={groundGeometry}
        />
      );
    }
    if (type === 'SHORT_TRACK') {
      return (
        <ShortTrack
          debug={debug}
          groundData={groundDataObj}
          scale={scale}
          vertices={vertices ?? false}
          showInDrawer={!!showInDrawer}
          groundGeometry={groundGeometry}
        />
      );
    }
    if (type === 'FENCING') {
      return (
        <Fencing
          debug={debug}
          groundData={groundDataObj}
          scale={scale}
          vertices={vertices ?? false}
          groundGeometry={groundGeometry}
        />
      );
    }
    if (type === 'TENNIS') {
      return (
        <Tennis
          debug={debug}
          groundData={groundDataObj}
          scale={scale}
          vertices={vertices ?? false}
          groundGeometry={groundGeometry}
        />
      );
    }
    return null;
  }, [groundData, scale, groundGeometry, vertices, showInDrawer]);

  if (!groundData || defaultGround) {
    return null;
  }

  return groundType(groundData, groundData.groundType);
};
